/*
import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import "./MyCourses.css";
import Footer from "./Footer";

const API = "https://course-selling-backend-2-rr1n.onrender.com";

function MyCourses() {
  const [myCourses, setMyCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [progress, setProgress] = useState({});

  useEffect(() => {
    const fetchMyCourses = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get(`${API}/api/users/my-courses`, {
          headers: { "x-auth-token": token },
        });
        setMyCourses(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMyCourses();
  }, []);

  return (
    <>
      <Navbar />
      <div className="dashboard-container">
        
        <div className="dashboard-header">
          <h2>📚 My Learning Dashboard</h2>
          <p>Track and continue your enrolled courses 🚀</p>
        </div>

        <h3 className="section-title">🎬 My Course Videos</h3>

        <div className="dashboard-grid">
         
          <div className="course-list">
            {myCourses.length === 0 ? (
              <div className="no-courses">
                <h3>You have not purchased any courses yet 😔</h3>
                <p>
                  Browse our <a href="/courses" style={{color : `black` , textDecoration : `Underline` }}>Courses</a> and start learning today!
                </p>
              </div>
            ) : (
              myCourses.map((c) => (
                <div className="course-card" key={c._id}>
                  {c.thumbnail && (
                    <img
                      src={`${API}${c.thumbnail}`}
                      className="course-thumbnail"
                    />
                  )}
                  <div className="course-content">
                    <h4>{c.title}</h4>

                    
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${progress[c._id] || 0}%` }}
                      ></div>
                    </div>
                    <p className="progress-text">
                      {progress[c._id] || 0}% completed
                    </p>
                  </div>

                  <button
                    className="continue-btn"
                    onClick={() => setSelectedCourse(c)}
                  >
                    Continue Learning
                  </button>
                </div>
              ))
            )}
          </div>

        
          <div className="video-player">
            {selectedCourse ? (
              <div className="video-card">
                <h4>{selectedCourse.title}</h4>

                {selectedCourse.videos &&
                  selectedCourse.videos.map((video, i) => {
                    const videoId =
                      video.split("v=")[1]?.split("&")[0] ||
                      video.split("youtu.be/")[1];
                    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

                    return (
                      <div key={i} className="video-box">
                        <h1>Lesson No : {`${i + 1}`}</h1>
                        <iframe
                          src={embedUrl}
                          title={`Video ${i}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          onLoad={() => {
                            setProgress((prev) => ({
                              ...prev,
                              [selectedCourse._id]: Math.min(
                                (prev[selectedCourse._id] || 0) + 20,
                                100
                              ),
                            }));
                          }}
                        ></iframe>
                      </div>
                    );
                  })}
              </div>
            ) : myCourses.length === 0 ? (
              <p className="placeholder">No course selected</p>
            ) : (
              <p className="placeholder">Select a course to start learning</p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
\\
export default MyCourses;


*/


import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./MyCourses.css";

const API = "https://course-selling-backend-2-rr1n.onrender.com";

function MyCourses() {
  const [myCourses, setMyCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [progress, setProgress] = useState({});

  useEffect(() => {
    
    const fetchMyCourses = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get(`${API}/api/users/my-courses`, {
          headers: { "x-auth-token": token },
        });

        console.log("MY COURSES RESPONSE:", res);
        setMyCourses(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMyCourses();
  }, []);

  const handleSelectCourse = (course) => {
    setSelectedCourse(course);
    if (course.videos && course.videos.length > 0) {
      setCurrentVideo(course.videos[0]);
    }
  };

  const handleVideoChange = (video, index) => {
    setCurrentVideo(video);
    setProgress((prev) => ({
      ...prev,
      [selectedCourse._id]: Math.min(
        ((index + 1) / selectedCourse.videos.length) * 100,
        100
      ),
    }));
  };

  // ✅ Convert Google Drive URL to playable format
  const getDriveEmbedUrl = (url) => {
    const fileId = url.split("/d/")[1]?.split("/")[0];
    return `https://drive.google.com/file/d/${fileId}/preview`;
  };

  return (
    <>
      <Navbar />
      <div className="mycourses-container">
        <div className="dashboard-header">
          <h2>🎓 My Learning Dashboard</h2>
          <p>Continue your journey, track progress, and watch your lessons.</p>
        </div>

        <div className="dashboard-layout">
          {/* Sidebar */}
          <aside className="course-sidebar">
            <h3>My Courses</h3>
            {myCourses.length === 0 ? (
              <div className="no-courses">
                <p>
                  You haven’t enrolled in any course yet.{" "}
                  <a href="/courses">Browse Courses</a>
                </p>
              </div>
            ) : (
              myCourses.map((course) => (
                <div
                  className={`course-item ${selectedCourse?._id === course._id ? "active" : ""
                    }`}
                  key={course._id}
                  onClick={() => handleSelectCourse(course)}
                >
                  {course.thumbnail && (
                    <img
                      src={
                        course.thumbnail.startsWith("http")
                          ? course.thumbnail
                          : `${API}${course.thumbnail}`
                      }
                      alt={course.title}
                      className="course-thumb"
                    />
                  )}

                  <div className="course-info">
                    <h4>{course.title}</h4>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${progress[course._id] || 0}%` }}
                      ></div>
                    </div>
                    <p className="progress-text">
                      {Math.floor(progress[course._id] || 0)}% complete
                    </p>
                  </div>
                </div>
              ))
            )}
          </aside>

          {/* Main Video Area */}
          <section className="video-section">
            {selectedCourse ? (
              <>
                <div className="video-player-box">
                  {currentVideo ? (
                    <iframe
                      src={getDriveEmbedUrl(currentVideo)}
                      title="Course Video"
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <p className="placeholder">Select a video to start learning</p>
                  )}
                </div>

                <div className="video-list">
                  <h4>📺 Lessons in {selectedCourse.title}</h4>
                  <div className="video-scroll">
                    {selectedCourse.videos.map((video, i) => (
                      <div
                        key={i}
                        className={`video-item ${currentVideo === video ? "playing" : ""
                          }`}
                        onClick={() => handleVideoChange(video, i)}
                      >
                        <span className="video-index">{i + 1}</span>
                        <p>Lesson {i + 1}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <div className="placeholder">
                <p>Select a course to start learning 🎯</p>
              </div>
            )}
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MyCourses;
